import FullScreenLayout from '@/_containers/layouts/full-screen';

export function Layout({ children }: { children: React.ReactNode }) {
  return <FullScreenLayout>{children}</FullScreenLayout>;
}
